// Custom navigation hook to work with our custom routing system
// This replaces react-router-dom's useNavigate

export function useNavigate() {
  return (path: string) => {
    // Remove leading slash if present
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    
    // Update URL
    window.history.pushState({}, '', `/${cleanPath}`);
    
    // Trigger popstate event to update the view
    window.dispatchEvent(new PopStateEvent('popstate'));
  };
}
